import { useState, useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { FaRegUser } from "react-icons/fa";
import { fetchAllUsers } from "../../api/users";

export default function ReportListFilters({onChange}) {
        const [worker, setWorker] = useState("");


        useEffect(() => { 
            onChange({worker});
         }, [worker, onChange]);

        const { data: users = []} = useQuery({
                queryKey: ['users'],
                queryFn: fetchAllUsers
        })

        return (
        <>
                {/* Filter row */}
                <div className="flex gap-2 w-full mb-1">
                        {/* Worker Select */}
                        <div className="relative flex-1">
                                <FaRegUser className="absolute left-3 top-1/2 -translate-y-1/2 text-primary-10 text-xs pointer-events-none"/>
                                <options value="" disabled hidden></options>
                                <select
                                        value={worker}
                                        onChange={(e) => setWorker(e.target.value)}
                                        className="w-full appearance-none bg-primary-800 border border-primary-50 text-primary-10 
                                        rounded-xl pl-8 pr-3 py-2.5 text-xs font-mono focus:outline-none focus:border-secondary-800 focus-ring-1 focus:ring-seondary-800">
                                        {users.map((u, i) => (
                                                <option value={u.telegram_id} key={i}>{u.name}</option>
                                        ))}
                                </select>
                        </div>
                </div>
        </>);
}